import { useStoreSelector } from 'hooks/store'
import { useTranslation } from 'react-i18next'
import styles from '../User.module.scss'
import parse from 'html-react-parser'
import { formatAddress } from 'utils/user'
import { routes } from 'types/routes'
import Link from 'components/link/Link'
import AddressSwitcherBar from 'components/address-switcher-bar/AddressSwitcherBar'
import { selectCurrentAccount } from 'store/contact/slice.ts'
import { trackEvent } from 'utils/tracking.ts'

const Contact = () => {
  // Redux
  const account = useStoreSelector(selectCurrentAccount)

  // i18n
  const { t } = useTranslation('user')

  // Local constants
  const billingAddress = formatAddress(account.correspondenceAddress)

  return (
    <section className={styles['table-wrapper']}>
      <AddressSwitcherBar />

      <ul className={styles.table}>
        <li>
          <strong>{t(($) => $.contact.fields.preferences.title)}</strong>
          {account.deliveryMode ? t(($) => $.contact.fields.preferences[`receiving${account.deliveryMode}`]) : '—'}
        </li>

        <li>
          <strong>{t(($) => $.contact.fields.billing.title)}</strong>
          {billingAddress ? parse(billingAddress) : '—'}
        </li>
      </ul>

      <Link
        representation="button"
        isFullwidthMobile
        variant="secondary"
        className={styles.edit}
        href={routes.USER_EDIT_CONTACT}
        onNavigate={() => trackEvent({ category: 'user', object: 'edit_contact_info', action: 'start' })}
      >
        {t(($) => $.edit, {
          ns: 'common'
        })}
      </Link>
    </section>
  )
}

export default Contact
